/*
import axios, {AxiosInstance, AxiosRequestConfig, AxiosResponse, AxiosError} from 'axios';

export default function (options: { headers?: any } = {}) {
  const { headers = {} } = options;

  const aemAxiosClient = axios.create({
    headers: { ...headers },
  });

  // Request interceptor
  aemAxiosClient.interceptors.request.use(
    function (config) {
      config.headers = { ...config.headers };
      return config;
    },
    function (error) {
      return Promise.reject(error);
    },
  );

  aemAxiosClient.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      return Promise.reject(error);
    },
  );

  return aemAxiosClient;
}
*/
//no
import axios, { AxiosInstance, AxiosResponse, AxiosError } from 'axios';

interface CreateClientOptions {
  headers?: Record<string, string>;
}

const createAemAxiosClient = (options: CreateClientOptions = {}): AxiosInstance => {
  const { headers = {} } = options;

  const aemAxiosClient = axios.create({
    headers,
  });

  // Request interceptor
  aemAxiosClient.interceptors.request.use(
    (config) => {
      config.headers = { ...config.headers } as any;
      return config;
    },
    (error: AxiosError) => {
      return Promise.reject(error);
    },
  );

  // Response interceptor
  aemAxiosClient.interceptors.response.use(
    (response: AxiosResponse): AxiosResponse => {
      return response;
    },
    (error: AxiosError) => {
      return Promise.reject(error);
    },
  );

  return aemAxiosClient;
};

export default createAemAxiosClient;
